import React, { useEffect, useState } from "react"
import { ScrollView, Text, View, StyleSheet, TextInput, TouchableOpacity, Pressable } from "react-native";
import { store } from "../../../store/store";
import { RadioButton } from 'react-native-paper';
import AppStyles from "../../../AppStyles";
import AppTheme from "../../../AppTheme";
import { updateQuestionRenderState, updateReduxCurrentAnswer } from "../../services/redux/commonRedux";


export default function SingleChoiceFunc() {

    // const [selectedIndex, updateSeletedOption] = useState(-1);
    const [selectedData, updateSelectedData] = useState({
        selectedIndex: -1,
        allowInput: false,
        inputText: ''
    })
    const [data, updateData] = useState({
        ansData: {},
        questionData: {},
        render: false
    });

    function onSelectOption(index, text, questionData, option = {}, subq = {}, subqId = '') {
        console.log('clicked');

        updateSelectedData({
            selectedIndex: index,
            allowInput: option['too'] || option['text'],
            inputText: text,
        }); 
        const id = questionData['qid'];
        const rskey = questionData['rskey'];
        const ansVal = option['value'];
        const curretAns = {
            [id]: {
                id: id,
                [rskey]: ansVal,
                textInput: option['too'] || option['text'] ? { [option['value']]: text } : {}
            },
        }; 
        updateData({
            questionData: questionData,
            ansData: {},
            render: true
        }); 
        updateReduxCurrentAnswer(curretAns);
    }

    function checkSelectedOption(index, value) {
        if (data.ansData[data.questionData['qid']])
            var ansStr = data.ansData[data.questionData['qid']][data.questionData['rskey']];
        if (index == selectedData.selectedIndex || (value == ansStr)) {
            return 'checked'
        } else return 'unchecked'
    }

    function allowTextInput(index, value) {
        if (data.ansData[data.questionData['qid']])
            var ansStr = data.ansData[data.questionData['qid']][data.questionData['rskey']];
        return (data.questionData['options'][index]['too'] || data.questionData['options'][index]['text']) &&
            (index == selectedData.selectedIndex || (value == ansStr));
    }

    useEffect(() => {
        const reduxState = store.getState();
        if (reduxState.renderQuestionElement) {
            updateQuestionRenderState(false);
            if (reduxState.currentConsultationQuestion && reduxState.currentConsultationAnswer) {
                // console.log('answer and question data in SCTXT', reduxState.currentConsultationAnswer, reduxState.currentConsultationQuestion);
                const ansData = reduxState.currentConsultationAnswer;
                const qData = reduxState.currentConsultationQuestion;
                updateSelectedData({
                    selectedIndex: -1,
                    allowInput: false,
                    inputText: ansData[qData['qid']] ? ansData[qData['qid']]['textInput'][ansData[qData['qid']][qData['rskey']]] : ''
                }); updateData({
                    ansData: ansData,
                    questionData: qData,
                    render: true
                });
            }
        }
    })

    return <ScrollView>
        {
            data.render ? <View style={{ marginHorizontal: 16 }}>
                <Text style={AppStyles.questionText}>
                    {data.questionData['qstr']}
                </Text>

                {data.questionData['options'].map((option, index) =>
                    <View key={index} >
                        <Pressable  onPress={() => onSelectOption(index, '', data.questionData, option)} style={{flex: 1, flexDirection: 'row', justifyContent: 'flex-start',  alignItems: 'center', alignContent: 'center'}}>
                            <Text style={[AppStyles.applyFont,{ flexDirection: 'row', justifyContent: 'flex-start', }]}>
                                    <RadioButton onPress={() => onSelectOption(index, '', data.questionData, option)}
                                        style={{ fontSize: 14, width: 15, height: 15, background: AppTheme.color.primary }}
                                        value={index} status={checkSelectedOption(index, option.value)} color={AppTheme.color.primary}

                                    />
                                </Text>
                        <Text style={[AppStyles.applyFont,{ fontSize: 14, left: 10, bottom: 3, fontWeight: "500" }]}>{option.dispStr}</Text>

                        </Pressable>

                        {
                            allowTextInput(index, option.value) ?
                                <TextInput style={[AppStyles.quesInput, { marginHorizontal: 16, padding: 8 }]}
                                    multiline
                                    numberOfLines={4}
                                    placeholder={option.hint}
                                    defaultValue={selectedData.inputText}
                                    onChangeText={text => onSelectOption(index, text, data.questionData, option)}
                                    editable
                                    maxLength={40}
                                /> : <View />
                        }
                    </View>
                )}</View> : <View />
        }
        <View style={{height: 40}}/>
    </ScrollView>
}

const styles = StyleSheet.create({
    radioBtn: {
        paddingLeft: 6,
        alignItems: 'center',
        flexDirection: 'row',
        // marginBottom: 16,
        backgroundColor: 'white',
        // height: 55,
        elevation: 1,
        borderRadius: 4,
        fontSize: 14,
    }
})